export default {
  FETCH_DATA: 'bkcont_fetch_data',
  UPDATE_QUERY: 'bkcont_update_query',
  LOAD_MORE_DATA: 'bkcont_load_more_data',
  UPDATE_LOADING: 'bkcont_update_loading',
  UPDATE_SELECTED: 'bkcont_update_selected',
};
